export const STAFF_IMITATION_MODAL_ID = 'staff-imitation-modal';
